import InstructorListStatsRow from '../ui/InstructorListStatsRow';

/** Course list KPI row — thin wrapper around shared list stats component. */
export default function CourseListStatsRow(props) {
  return <InstructorListStatsRow variant="courses" {...props} />;
}
